import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import "./AdminNavbar.css";

export default function AdminNavbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showExit, setShowExit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const navigate = useNavigate();

  // Detect mobile screen
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleYes = () => {
    setLoading(true);
    setTimeout(() => {
      localStorage.removeItem("isAdminLoggedIn");
      navigate("/");
    }, 2000);
  };

  return (
    <>
      <nav className="admin-navbar">
        <div className="nav-left">
          <h2 className="nav-logo">Admin Panel</h2>
        </div>

        <div className="nav-right">
          {isMobile ? (
            <>
              <div
                className="menu-icon"
                onClick={() => setMenuOpen(!menuOpen)}
              >
                {menuOpen ? <FaTimes /> : <FaBars />}
              </div>

              <ul className={`nav-links mobile ${menuOpen ? "active" : ""}`}>
                <li><Link to="/admin" onClick={() => setMenuOpen(false)}>News Upload</Link></li>
                <li><Link to="/addsupport" onClick={() => setMenuOpen(false)}>Supporters Upload</Link></li>
                <li><Link to="/addtrustee" onClick={() => setMenuOpen(false)}>Trustee Upload</Link></li>
                <li><Link to="/galleryupload" onClick={() => setMenuOpen(false)}>Gallery Upload</Link></li>
                <li><Link to="/history" onClick={() => setMenuOpen(false)}>Donation List</Link></li>
                <li>
                  <button className="logout-btn" onClick={() => setShowExit(true)}>Logout</button>
                </li>
              </ul>
            </>
          ) : (
            <ul className="nav-links desktop">
              <li><Link to="/admin">News Upload</Link></li>
              <li><Link to="/addsupport">Supporters Upload</Link></li>
              <li><Link to="/addtrustee">Trustee Upload</Link></li>
              <li><Link to="/galleryupload">Gallery Upload</Link></li>
              <li><Link to="/history">Donation List</Link></li>

              <li>
                <button className="logout-btn" onClick={() => setShowExit(true)}>Logout</button>
              </li>
            </ul>
          )}
        </div>
      </nav>

      {/* EXIT CONFIRM */}
      {showExit && (
        <div className="exit-overlay">
          <div className="exit-box">
            {!loading ? (
              <>
                <h3>Are you sure you want to exit?</h3>
                <div className="exit-buttons">
                  <button className="yes-btn" onClick={handleYes}>Yes</button>
                  <button className="no-btn" onClick={() => setShowExit(false)}>No</button>
                </div>
              </>
            ) : (
              <div className="loader"></div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
